import { http_client } from '@/plugins/http_client';

const urlBase = 'api';
let url = '/api/v1/sanciones';

export const fetchSanciones = async (filters = {}) => {
  try {
    const {
      estado = null,
      tipo = null,
      search = '',
      empleadoId = null,
      unidadId = null,
      desde = null,
      hasta = null,
      page = 1,
      size = 25,
      sort = 'created_at',
      sortDirection = 'desc',
    } = filters || {};

    const body = {
      estado: estado === undefined ? null : estado,
      tipo: tipo === undefined ? null : tipo,
      search: search && search.trim() !== '' ? search.trim() : null,
      empleadoId: empleadoId || null,
      unidadId: unidadId || null,
      desde: desde || null,
      hasta: hasta || null,
      page: page || 1,
      size: size || 25,
      sort: sort || 'created_at',
      sortDirection: sortDirection || 'desc',
    };
    const response = await http_client(`${urlBase}/sanciones/listar-sanciones`, body, 'POST');
    const apiData = response?.data || response;

    const sancionesArray = apiData?.data?.sanciones || [];
    const meta = apiData?.data?.meta || {};
    const mappedData = Array.isArray(sancionesArray)
      ? sancionesArray.map((item, index) => ({
          id: item.id,
          codigo: ((page - 1) * (meta.per_page || size || 10)) + index + 1,
          fecha_solicitud: item.fechaSolicitud,
          tipo_sancion: item.tipoSancion?.nombre || item.tipoSancion || '',
          documento: item.empleado?.persona?.usuario?.documento || '',
          nombre: item.empleado?.persona?.usuario?.nombres || '',
          apellido: item.empleado?.persona?.usuario?.apellidos || '',
          nombreEmpleado: item.empleado?.persona?.usuario?.nombres || '',
          unidad_organizativa: item.unidadOrganizativa?.nombre || '',
          // Nuevos campos solicitados
          plaza: item.plaza || item.plaza?.denominacion || item.denominacionPlaza || item.datosPlaza?.denominacionPlaza || '',
          cargo: item.cargo || '',
          estado: item.estadoSolicitud?.nombre || item.estadoSolicitud || '',
          acuerdo: item.acuerdo || false,
        nivelGravedad: item.nivelGravedad || '',
        }))
      : [];

    return {
      data: mappedData,
      total: meta.total || 0,
      page: meta.current_page || 1,
      perPage: meta.per_page || 10,
      lastPage: meta.last_page || 1,
    };

  } catch (error) {
    console.error('Error al obtener sanciones:', error);
    return { data: [], total: 0, page: 1, perPage: 10 };
  }
};

export const fetchSancionEmpleado = async (id) => {
  try {
    const response = await http_client(`${urlBase}/sanciones/get-sancion-empleado/${id}`, {}, 'GET');
    const apiData = response?.data?.data || response?.data || response;

    return {
      datosPersonales: {
        empleadoNombre: apiData.datosPersonales?.empleadoNombre || '',
        empleadoFoto: apiData.datosPersonales?.empleadoFoto || null,
        tipoDocumento: apiData.datosPersonales?.tipoDocumento || '',
        numeroDocumento: apiData.datosPersonales?.numeroDocumento || '',
        paisNacimiento: apiData.datosPersonales?.paisNacimiento || '',
        fechaNacimiento: apiData.datosPersonales?.fechaNacimiento || '',
        telefonoPersonal: apiData.datosPersonales?.telefonoPersonal || '',
        departamentoResidencia: apiData.datosPersonales?.departamentoResidencia || '',
        distritoResidencia: apiData.datosPersonales?.distritoResidencia || '',
        direccion: apiData.datosPersonales?.direccion || '',
        emailInstitucional: apiData.datosPersonales?.emailInstitucional || '',
        fechaContratacion: apiData.datosPersonales?.fechaContratacion || '',
        establecimiento: apiData.datosPersonales?.establecimiento || '',
        unidadOrganizativa: apiData.datosPersonales?.unidadOrganizativa || '',
        estadoEmpleado: apiData.datosPersonales?.estadoEmpleado || '',
        modalidadContratacion: apiData.datosPersonales?.modalidadContratacion || '',
        tiempoServicio: apiData.datosPersonales?.tiempoServicio?.formato_largo || null,
      },
      estadoActual: apiData.estadoActual || null,
      tipoSancion: apiData.tipoSancion || '',
      faltaCometida: apiData.faltaCometida || '',
      archivos: {
        adjuntos: Array.isArray(apiData.archivos?.adjuntos)
          ? apiData.archivos.adjuntos.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        actaJustificacion: Array.isArray(apiData.archivos?.acta_justificacion)
          ? apiData.archivos.acta_justificacion.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        resolucionExterna: Array.isArray(apiData.archivos?.resolucionExterna)
          ? apiData.archivos.resolucionExterna.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        acuerdos: Array.isArray(apiData.archivos?.acuerdos)
          ? apiData.archivos.acuerdos.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
      },
      sancionesAplicadas: {
        ...(apiData.sancionesAplicadas || {}),
        tipoSancionId: apiData.sancionesAplicadas?.tipoSancionId ?? apiData.tipoSancionId ?? null,
        montoPagar: apiData.sancionesAplicadas?.montoPagar ?? null,
        porcentajeRebajaSalario: apiData.sancionesAplicadas?.porcentajeRebajaSalario ?? null,
        categoriaTemporal: apiData.sancionesAplicadas?.categoriaTemporal ?? null,
        fechaInicioSancion: apiData.sancionesAplicadas?.fechaInicioSancion ?? null,
        fechaFinSancion: apiData.sancionesAplicadas?.fechaFinSancion ?? null,
      },
      observaciones: apiData.observaciones || null,
      historialSanciones: Array.isArray(apiData.historialSanciones)
        ? apiData.historialSanciones.map(sancion => ({
            id: sancion.id || null,
            fecha: sancion.fecha || '',
            tipoSancion: sancion.tipoSancion || '',
            detalles: {
              ...sancion.detalles,
              tipoSancionId: sancion.detalles?.tipoSancionId ?? sancion.tipoSancionId ?? null,
            },
          }))
        : [],
      // Pasar datos de la plaza tal como vienen del API para que la vista los consuma/normalice
      datosPlaza: apiData.datosPlaza || null,
      listaSanciones: apiData?.sancionesAplicadas || []
    };
  } catch (error) {
    console.error('Error al obtener detalle de sanción del empleado:', error);
    throw error;
  }
};

export const fetchSancionEmpleadoResoluciones = async (id) => { // resoluciones
  try {
    const response = await http_client(`${urlBase}/sanciones/get-sancion-empleado/${id}`, {}, 'GET');
    const apiData = response?.data?.data || response?.data || response;

    return {
      datosPersonales: {
        empleadoNombre: apiData.datosPersonales?.empleadoNombre || '',
        empleadoFoto: apiData.datosPersonales?.empleadoFoto || null,
        tipoDocumento: apiData.datosPersonales?.tipoDocumento || '',
        numeroDocumento: apiData.datosPersonales?.numeroDocumento || '',
        paisNacimiento: apiData.datosPersonales?.paisNacimiento || '',
        fechaNacimiento: apiData.datosPersonales?.fechaNacimiento || '',
        telefonoPersonal: apiData.datosPersonales?.telefonoPersonal || '',
        departamentoResidencia: apiData.datosPersonales?.departamentoResidencia || '',
        distritoResidencia: apiData.datosPersonales?.distritoResidencia || '',
        direccion: apiData.datosPersonales?.direccion || '',
        emailInstitucional: apiData.datosPersonales?.emailInstitucional || '',
        fechaContratacion: apiData.datosPersonales?.fechaContratacion || '',
        establecimiento: apiData.datosPersonales?.establecimiento || '',
        unidadOrganizativa: apiData.datosPersonales?.unidadOrganizativa || '',
        estadoEmpleado: apiData.datosPersonales?.estadoEmpleado || '',
        modalidadContratacion: apiData.datosPersonales?.modalidadContratacion || '',
        tiempoServicio: apiData.datosPersonales?.tiempoServicio?.formato_largo || null,
      },
      estadoActual: apiData.estadoActual || null,
      tipoSancion: apiData.tipoSancion || '',
      tipoSancionId: apiData.tipoSancionId || '',
  nivelGravedad: apiData.nivelGravedad || apiData?.nivel_gravedad || '',
      
      faltaCometida: apiData.faltaCometida || '',
      archivos: {
        adjuntos: Array.isArray(apiData.archivos?.adjuntos)
          ? apiData.archivos.adjuntos.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        actaJustificacion: Array.isArray(apiData.archivos?.acta_justificacion)
          ? apiData.archivos.acta_justificacion.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        resolucionExterna: Array.isArray(apiData.archivos?.resolucionExterna)
          ? apiData.archivos.resolucionExterna.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
        acuerdos: Array.isArray(apiData.archivos?.acuerdos)
          ? apiData.archivos.acuerdos.map(archivo => ({
              nombre: archivo.nombre || '',
              tipo: archivo.tipo || '',
              url: archivo.url || '',
              show: true,
              base64_archivo: archivo.base64_archivo || null,
            }))
          : [],
      },
      sancionesAplicadas: apiData.sancionesAplicadas || {
        montoPagar: null,
        porcentajeRebajaSalario: null,
        categoriaTemporal: null,
        fechaInicioSancion: null,
        fechaFinSancion: null,
      },
      observaciones: apiData.observaciones || null,
      historialSanciones: Array.isArray(apiData.historialSanciones)
        ? apiData.historialSanciones.map(sancion => ({
            id: sancion.id || null,
            fecha: sancion.fecha || '',
            tipoSancion: sancion.tipoSancion || '',
            detalles: sancion.detalles || {},
          }))
        : [],
        datosPlaza: apiData.datosPlaza || null
    };

  } catch (error) {
    console.error('Error al obtener detalle de sanción del empleado:', error);
    throw error;
  }
}; /* end fetchSancionEmpleadoResoluciones */

export const fetchSancionProcede = async (id_solicitud, procede = 'no') => {
  try {
    const response = await http_client(
      `${urlBase}/sanciones/${id_solicitud}/procede`,
      { procede }, // ahora enviamos "procede" en el body
      'POST'
    );

    const apiData = response?.data || response;

    return {
      procede: apiData.procede || 'no'
    };

  } catch (error) {
    console.error('Error al consultar si la sanción procede:', error);
    throw error;
  }
};

export const fetchSancionesCategoriasPlazas = async () => {
  try {
    // Petición GET al endpoint
    const response = await http_client(
      `${urlBase}/catalogos/sanciones-categorias-plazas`,
      {},
      'GET'
    );

    // Obtener los datos en el formato esperado
    const apiData = response?.data?.data || response?.data || [];

    // Solo devolver los campos que te interesan
    const categorias = Array.isArray(apiData)
      ? apiData.map(item => ({
          id: item.id || null,
          nombre: item.nombre || '',
          ctl_categoria_plaza: item.ctl_categoria_plaza || ''
        }))
      : [];

    return categorias;
  } catch (error) {
    console.error('Error al obtener categorías de plazas de sanciones:', error);
    throw error;
  }
};

export default {
  fetchSanciones,
  fetchSancionEmpleado,
  fetchSancionEmpleadoResoluciones,
  fetchSancionProcede
};
